/**
 * Detects if the current browser is a mobile webview
 * @returns {boolean} true if running in a mobile webview, false otherwise
 */
export const isMobileWebview = () => {
  if (typeof window === 'undefined' || !window.navigator) {
    return false;
  }

  const userAgent = window.navigator.userAgent || '';
  const lowerUA = userAgent.toLowerCase();

  // Common webview indicators:
  // - Android WebView: contains "wv" in user agent
  // - iOS WebView: contains "Mobile" and specific patterns
  // - Facebook in-app browser
  // - Instagram in-app browser
  // - Twitter in-app browser
  // - LinkedIn in-app browser
  // - WeChat browser
  // - Custom app webviews often have specific patterns

  const webviewPatterns = [
    /wv/i, // Android WebView
    /fbav/i, // Facebook in-app browser
    /fban/i, // Facebook in-app browser
    /fbsv/i, // Facebook in-app browser
    /instagram/i, // Instagram in-app browser
    /line/i, // LINE in-app browser
    /wechat/i, // WeChat browser
    /micro messager/i, // WeChat browser (alternative)
    /qqbrowser/i, // QQ Browser
    /mqqbrowser/i, // Mobile QQ Browser
    /baiduboxapp/i, // Baidu Box App
    /baidubrowser/i, // Baidu Browser
    /ucbrowser/i, // UC Browser
    /quark/i, // Quark Browser
    /sogou/i, // Sogou Browser
  ];

  // Check if user agent matches any webview pattern
  const isWebview = webviewPatterns.some(pattern => pattern.test(userAgent));

  // Additional check: iOS webview detection
  // iOS webviews often have "Mobile" but lack "Safari" or have specific version patterns
  const isIOS = /iphone|ipad|ipod/i.test(userAgent);
  const hasMobile = /mobile/i.test(userAgent);
  const hasSafari = /safari/i.test(userAgent);
  
  // iOS webview: has Mobile but might not have Safari, or has specific webkit version
  const isIOSWebview = isIOS && hasMobile && (!hasSafari || /version\/[\d.]+.*mobile.*safari/i.test(userAgent));

  return isWebview || isIOSWebview;
};
